import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-11-08 18:21:35
 * @LastEditTime: 2021-11-08 19:13:11
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React, { useEffect, useState } from 'react';
import { useStore, getFormValue } from '@/store/index.js'; // eslint-disable-next-line import/no-cycle

import Render from '../Render';

const PolicyholdersExemptionModule = (props = {}) => {
  const {
    attrs,
    children
  } = props;
  const holderExemptionList = useStore('holderExemptionList') || [];
  const key = holderExemptionList[0] || '';
  const isShowModule = useStore(`formValues.${key}`) === 'Y';
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowModule && /*#__PURE__*/React.createElement(Render, _extends({}, props, {
    components: children
  })));
};

export default PolicyholdersExemptionModule;